import { render, staticRenderFns } from "./interactive-hotspot.vue?vue&type=template&id=4ac0dc44&scoped=true&"
import script from "./interactive-hotspot.vue?vue&type=script&lang=js&"
export * from "./interactive-hotspot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac0dc44",
  null
  
)

export default component.exports